import { PaginaNode, TonalitaDetailObject } from '@gql/graphql'
import { useTrans } from 'hooks'
import { imgUrl } from '@utils/mock'
import {
  Banner,
  BannerCertificazioni,
  HeroTonalita,
  Page,
  Prefooter,
  SuperficiTonalita,
  TonalitaSection,
} from 'components/organisms'
import styles from './TonalitaDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  tonalita?: TonalitaDetailObject
}

const TonalitaDetailTemplate = (props: Props) => {
  const { pagina = undefined, tonalita = undefined } = props
  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <HeroTonalita tonalita={tonalita} />
        <SuperficiTonalita tonalita={tonalita} />
        <BannerCertificazioni
          item={{
            name: t('Certificazioni'),
            children:
              tonalita.tonalitaCollezione?.certificazioni?.map((x) => ({
                pk: x.pk,
                name: x.title,
                url: x.url,
              })) || [],
          }}
        />
        <TonalitaSection tonalita={tonalita} />
        <Banner
          item={{
            name: tonalita.collezione.title,
            description: tonalita.collezione.sottotitolo,
            ctaLabel: t('Scopri la Collezione'),
            url: tonalita.collezione.url,
            image:
              tonalita.collezione?.gallery && tonalita.collezione?.gallery.length > 0
                ? tonalita.collezione.gallery[0].url
                : imgUrl(820, 500),
          }}
          type="left"
          theme="neutral10"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default TonalitaDetailTemplate
